/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const Login = props => {
    const {
        socialId,
        xfbml,
        cookie,
        version,
        fields,
        responseHandler,
        children,
        buttonText,
        language,
        scope,
        ...rest
    } = props;

    const responseApi = authResponse => {
        window.FB.api('/me', { fields }, me => {
            responseHandler({
                ...me,
                accessToken: authResponse.accessToken
            });
        });
    };

    const checkLoginState = response => {
        if (response.authResponse) {
            responseApi(response.authResponse);
        } else {
            responseHandler({ status: response.status });
        }
    };

    const clickHandler = () => {
        window.FB.login(checkLoginState, { scope });
    };

    React.useEffect(() => {
        ((d, s, id) => {
            const element = d.getElementsByTagName(s)[0];
            const fjs = element;
            let js = element;
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = `//connect.facebook.net/${language}/sdk.js`;
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');

        window.fbAsyncInit = () => {
            window.FB.init({
                appId: socialId,
                xfbml,
                cookie,
                version
            });
        };
    }, [socialId, xfbml, cookie, version, language]);

    return (
        <button type="button" onClick={clickHandler} {...rest}>
            {children}
            {buttonText}
        </button>
    );
};

export default React.memo(Login);

Login.propTypes = {
    socialId: PropTypes.string.isRequired,
    xfbml: PropTypes.bool.isRequired,
    version: PropTypes.string.isRequired,
    fields: PropTypes.string.isRequired,
    responseHandler: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    cookie: PropTypes.bool,
    scope: PropTypes.string.isRequired,
    buttonText: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};

Login.defaultProps = {
    cookie: false,
    buttonText: 'Facebook Login',
    children: null
};
